export default "__VITE_ASSET__C8Hl8m_N__"